import { create, STORAGE_ZUSTAND_KEYS } from "@/modules/core/store"
import { createJSONStorage, persist } from "zustand/middleware"

type CurrentSpaceManagerState = {
  boxId: string | null
  coachId: string | null
}

type CurrentSpaceManagerActions = {
  actions: {
    setBoxId: (boxId: string | null) => void
    setCoachId: (coachId: string | null) => void
  }
}

type CurrentSpaceManager = CurrentSpaceManagerState & CurrentSpaceManagerActions

export const useCurrentSpaceManagerStore = create<CurrentSpaceManager>()(
  persist(
    (set) => ({
      boxId: null,
      coachId: null,
      actions: {
        setBoxId: (boxId: string | null) => set({ boxId, coachId: null }),
        setCoachId: (coachId: string | null) => set({ boxId: null, coachId }),
      },
    }),
    {
      name: STORAGE_ZUSTAND_KEYS.CURRENT_SPACE_MANAGER,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        boxId: state.boxId,
        coachId: state.coachId,
      }),
    },
  ),
)

export const useCurrentBoxId = () => {
  return useCurrentSpaceManagerStore((state) => state.boxId)
}

export const useCurrentCoachId = () => {
  return useCurrentSpaceManagerStore((state) => state.coachId)
}

export const useCurrentSpaceManagerActions = () => {
  return useCurrentSpaceManagerStore((state) => state.actions)
}
